module.exports = __webpack_public_path__ + "img/LanceleauScreenshot2_1920x1080.bf57c962.png";